export default "__VITE_ASSET__DUi5nKEE__"